var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 5.5V19.5H5.5V5.5H19.5ZM11.3925 9H10.0291L7.44053 16H8.6706L9.15931 14.6316H12.258L12.7362 16H14.0404L11.3925 9ZM16.2239 9H14.9988V16H16.2239V9ZM10.7005 10.1744L11.9208 13.6666H9.49957L10.7005 10.1744ZM20.6667 16H23V18.3333H20.6667V16ZM6.66667 20.6667H9V23H6.66667V20.6667ZM11.3333 20.6667H13.6667V23H11.3333V20.6667ZM6.66667 2H9V4.33333H6.66667V2ZM16 20.6667H18.3333V23H16V20.6667ZM11.3333 2H13.6667V4.33333H11.3333V2ZM16 2H18.3333V4.33333H16V2ZM20.6667 11.3333H23V13.6667H20.6667V11.3333ZM2 16H4.33333V18.3333H2V16ZM20.6667 6.66667H23V9H20.6667V6.66667ZM2 11.3333H4.33333V13.6667H2V11.3333ZM2 6.66667H4.33333V9H2V6.66667Z",
    fill: "#1C459B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.f9910d054dd6f9f29e5583efb709990a.svg";
export { ForwardRef as ReactComponent };